import { render, staticRenderFns } from "./DeletedList.vue?vue&type=template&id=6e3a762a&scoped=true&"
import script from "./DeletedList.vue?vue&type=script&lang=js&"
export * from "./DeletedList.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=6e3a762a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a762a",
  null
  
)

export default component.exports